// extracted by mini-css-extract-plugin
export var sliderRange = "_qq-2";
export var sliderRoot = "_qq-0";
export var sliderThumb = "_qq-3";
export var sliderTrack = "_qq-1";